
const Footer = () => {

    return (
        <footer className="w-full flex items-end justify-between py-6 px-4 border-t border-neutral-50">
            <div className="flex flex-col gap-2">
                <p className="text-sm">&copy; {new Date().getFullYear()} HelpMeVote.ng</p>
                <p className="text-xs">Made with ❤️ in Nigeria</p>
            </div>
            <ul className="flex flex-col ">
                <li>
                    <a className="text-sm hover:text-gray-600" href="https://docs.google.com/document/d/1Sr_7VFCmp06iMUPhFhwGLqVtzYmzklsKeX3cDdklx8c/edit">Terms of service </a>
                </li>
                <li>
                    <a className="text-sm hover:text-gray-600" href="https://docs.google.com/document/d/1Sr_7VFCmp06iMUPhFhwGLqVtzYmzklsKeX3cDdklx8c/edit">Privacy policy </a>
                </li>
                <li>
                    <a className="text-sm hover:text-gray-600" href="https://docs.google.com/document/d/e/2PACX-1vS7x9z8dVP0ssWYYl1K44qwtgZ5DHnoeF63_1tO0jnQpUFUXoY6l_Bzxc3q-_YwBcw207urhCSniV8F/pub">Team </a>
                </li>
            </ul>
        </footer>
    )
}

export default Footer;
